import { useQuery } from '@tanstack/react-query'
import { accountGroupService } from '../../../../service/AccountGroupService'
import { accountGroupKeys } from '../../../../data/queryFactories'
import { showErrorToast, toastKey } from '../../../../utils/showToast'
function mapAccountGroup(data) {
  return {
    createdAt: data?.createdAt,
    createdBy: data?.createdBy,
    name: data?.name,
    description: data?.description,
    uuid: data?.uuid,
  }
}
export default function useGetAccountGroup() {
  const { data, isLoading, error } = useQuery({
    queryFn: async () => {
      const { success, message } = await accountGroupService.getAll()
      if (!success) {
        throw new Error(message.content)
      }
      if (message?.content) {
        return { groups: message.content.map(mapAccountGroup) }
      }
      throw new Error('Lấy danh sách nhóm người dùng lỗi')
    },
    queryKey: accountGroupKeys.list({}),
  })
  if (error) {
    showErrorToast({
      error: error.message,
      message: 'Lấy thông tin thất bại vui lòng liên hệ admin',
      toastId: toastKey.ACCOUNT.GROUP.LIST,
    })
  }
  return { data, isLoading, error }
}
